module.exports = ".current-one {\n  background-color: #f8fafb !important; }\n\n.Fileright {\n  width: 45rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/worker/worker-safetybox/worker-safetybox.component.scss
// module id = ./src/app/worker/worker-safetybox/worker-safetybox.component.scss
// module chunks = main